import styled from "styled-components";
import { MdKeyboardArrowRight, MdArrowForward } from "react-icons/md"

export const HeroContainer = styled.div`
    background: #0c0c0c;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 30px;
    //height: 800px;
    height: 100vh;
    position: relative;
    z-index: 1;

    :before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        // background: linear-gradient(180deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.6) 100%),
        // linear-gradient(180deg, rgba(0,0,0,0.2) 0%, transparent 100%);
        // z-index: 2;
    }

`

export const HeroBg = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left:  0;
    width: 100%;
    height: 100%;
    overflow: hidden;

`

export const VideoBg = styled.video`
    width: 100%;
    height: 100%;
    --o-object-fit: cover;
    object-fit: cover;
    background: #232a34;
    opacity: 0.5;

    /* Hide video controls for all devices */
    &::-webkit-media-controls {
        display: none !important;
    }
    &::-webkit-media-controls-enclosure {
        display: none !important;
    }
    &::-webkit-media-controls-panel {
        display: none !important;
    }
    &::-moz-media-controls {
        display: none !important;
    }
`

export const HeroContent = styled.div`
    z-index: 3;
    max-width: 1200px;
    position: absolute;
    padding: 8px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;

`

export const HeroBtnWrapper = styled.div`
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;

`

export const ArrowForward = styled(MdArrowForward)`
    margin-left: 8px;
    font-size: 20px;

`

export const ArrowRight = styled(MdKeyboardArrowRight)`
    margin-left: 8px;
    font-size: 20px;
`

export const HeroLogo = styled.img`
    width: 120px;
    height: 120px;
    background: white;
    border-radius: 50%;
    padding: 15px;
    object-fit: contain;
    margin-bottom: 24px;
    box-shadow: 0 4px 20px rgba(255, 255, 255, 0.3);
`
